import {Contact} from "types/Contact";
import {dateTime} from "services/date";

/**
 * Transform the given contact by deserializing object properties
 *
 * @internal
 * @param contact
 */
export default function deserializeContact(contact: any): Contact {
    contact.created_at = dateTime(contact.created_at)
    contact.updated_at = dateTime(contact.updated_at)

    return contact;
}